import HttpActionService from './HttpActionsService'
import { Nav } from '../Model/Nav'
import UserStore from '../Stores/UserStore'
import { history } from '../Routing'

export default class AuthService {
    private static _instance: AuthService

    refreshTokenInterval: number

    // private constructor() {
    // }

    public static getInstance(): AuthService {
        return this._instance || (this._instance = new this())
    }

    public refreshStart() {
        if (Number(window.localStorage.getItem('expiresIn'))) {
            this.refreshTokenInterval = Number(window.localStorage.getItem('expiresIn')) / 2 * 1000
        } else {
            this.refreshTokenInterval = 180000 // just hack
        }
        setInterval(
            () => {
                HttpActionService.getInstance().refreshOAuthTokens()
                Nav.getInstance().addRoleDependentItems()
            },
            this.refreshTokenInterval
        )
    }

    public checkSessionAndRedirect() {
        let linksAnonymousAccessMatch = [
            '/credit/([0-9]*)$',
            '/Credit/([0-9]*)$',
            '/RecoveryPassword',
            '/recoveryPassword',
            '/ConfirmEmailSuccess',
            '/confirmEmailSuccess',
            '/confirmEmailFail',
            '/ConfirmEmailFail'
        ]

        if (linksAnonymousAccessMatch.some(x => {
             return history.location.pathname.match(x) ? true : false
        })) {
            return
        }

        if (!UserStore.getInstance().checkSession) {
            history.push('/login')
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Services/AuthService.tsx